import type { Order, Product } from "./domain";

export const products: Product[] = [
  {
    id: "frozen-original",
    name: "Frozen Kebab Original",
    description: "Rasa original dengan daging cincang premium Alabian.",
    variants: ["Kecil isi 5", "Kecil isi 10", "Besar isi 5"],
    unit: "box",
    demoPrices: { customer: 24000, reseller: 24000, partner: 24000 },
    variantPrices: {
      "Kecil isi 5": { customer: 24000, reseller: 24000, partner: 24000 },
      "Kecil isi 10": { customer: 40000, reseller: 40000, partner: 40000 },
      "Besar isi 5": { customer: 40000, reseller: 40000, partner: 40000 },
    },
    imageUrl: "/assets/products/original-mini.jpg",
    featured: true,
  },
  {
    id: "frozen-original-pedas",
    name: "Frozen Kebab Original Pedas",
    description: "Rasa original dengan sensasi pedas untuk pilihan keluarga.",
    variants: ["Kecil isi 5", "Kecil isi 10", "Besar isi 5"],
    unit: "box",
    demoPrices: { customer: 25000, reseller: 25000, partner: 25000 },
    variantPrices: {
      "Kecil isi 5": { customer: 25000, reseller: 25000, partner: 25000 },
      "Kecil isi 10": { customer: 42000, reseller: 42000, partner: 42000 },
      "Besar isi 5": { customer: 41000, reseller: 41000, partner: 41000 },
    },
    imageUrl: "/assets/products/product-stack.jpg",
  },
  {
    id: "frozen-barbeque",
    name: "Frozen Kebab Barbeque",
    description: "Saus barbeque gurih dengan isian daging cincang.",
    variants: ["Kecil isi 5", "Kecil isi 10", "Besar isi 5"],
    unit: "box",
    demoPrices: { customer: 27000, reseller: 27000, partner: 27000 },
    variantPrices: {
      "Kecil isi 5": { customer: 27000, reseller: 27000, partner: 27000 },
      "Kecil isi 10": { customer: 43000, reseller: 43000, partner: 43000 },
      "Besar isi 5": { customer: 43000, reseller: 43000, partner: 43000 },
    },
    imageUrl: "/assets/products/product-assortment.jpg",
  },
  {
    id: "frozen-bolognese",
    name: "Frozen Kebab Bolognese",
    description: "Paduan saus bolognese dan daging cincang premium.",
    variants: ["Kecil isi 5", "Kecil isi 10", "Besar isi 5"],
    unit: "box",
    demoPrices: { customer: 27000, reseller: 27000, partner: 27000 },
    variantPrices: {
      "Kecil isi 5": { customer: 27000, reseller: 27000, partner: 27000 },
      "Kecil isi 10": { customer: 43000, reseller: 43000, partner: 43000 },
      "Besar isi 5": { customer: 43000, reseller: 43000, partner: 43000 },
    },
    imageUrl: "/assets/products/meat-texture.jpg",
  },
  {
    id: "frozen-blackpepper",
    name: "Frozen Kebab Blackpepper",
    description: "Rasa lada hitam yang tegas dan aromatik.",
    variants: ["Kecil isi 5", "Kecil isi 10", "Besar isi 5"],
    unit: "box",
    demoPrices: { customer: 27000, reseller: 27000, partner: 27000 },
    variantPrices: {
      "Kecil isi 5": { customer: 27000, reseller: 27000, partner: 27000 },
      "Kecil isi 10": { customer: 43000, reseller: 43000, partner: 43000 },
      "Besar isi 5": { customer: 43000, reseller: 43000, partner: 43000 },
    },
    imageUrl: "/assets/products/product-stack.jpg",
  },
  {
    id: "frozen-cheesy-mayo",
    name: "Frozen Kebab Cheesy Mayo",
    description: "Isian creamy cheesy mayo untuk rasa yang lebih kaya.",
    variants: ["Kecil isi 5", "Kecil isi 10", "Besar isi 5"],
    unit: "box",
    demoPrices: { customer: 27000, reseller: 27000, partner: 27000 },
    variantPrices: {
      "Kecil isi 5": { customer: 27000, reseller: 27000, partner: 27000 },
      "Kecil isi 10": { customer: 43000, reseller: 43000, partner: 43000 },
      "Besar isi 5": { customer: 43000, reseller: 43000, partner: 43000 },
    },
    imageUrl: "/assets/products/cheesy-mayo-mini.jpg",
  },
  {
    id: "frozen-mozzarella",
    name: "Frozen Kebab Mozzarella",
    description: "Daging cincang premium dengan tambahan mozzarella.",
    variants: ["Kecil isi 5", "Kecil isi 10", "Besar isi 5"],
    unit: "box",
    demoPrices: { customer: 30000, reseller: 30000, partner: 30000 },
    variantPrices: {
      "Kecil isi 5": { customer: 30000, reseller: 30000, partner: 30000 },
      "Kecil isi 10": { customer: 55000, reseller: 55000, partner: 55000 },
      "Besar isi 5": { customer: 52000, reseller: 52000, partner: 52000 },
    },
    imageUrl: "/assets/products/meat-texture.jpg",
  }
];

export const demoOrders: Order[] = [
  {
    id: "demo-order-014",
    number: "AK-260822-014",
    customerName: "Agustina (Nana)",
    customerEmail: "nana@example.test",
    customerPhone: "0821-0000-0014",
    shippingAddress: "Bekasi, Jawa Barat",
    customerType: "reseller",
    status: "preparing",
    paymentStatus: "paid",
    priceReviewStatus: "confirmed",
    lines: [
      { productId: "frozen-original", productName: "Frozen Kebab Original", variant: "Mini isi 10", quantity: 2, unitPrice: 40000 },
      { productId: "frozen-cheesy-mayo", productName: "Frozen Kebab Cheesy Mayo", variant: "Mini isi 10", quantity: 1, unitPrice: 43000 }
    ],
    subtotal: 123000,
    shippingTotal: 0,
    discountTotal: 0,
    total: 123000,
    createdAt: "2026-08-22T10:24:00+07:00",
    printStatus: "not_printed"
  },
  {
    id: "demo-order-015",
    number: "AK-260822-015",
    customerName: "Pelanggan Demo",
    customerEmail: "pelanggan@example.test",
    customerPhone: "0821-0000-0015",
    shippingAddress: "Tambun, Bekasi",
    customerType: "customer",
    status: "new",
    paymentStatus: "pending",
    priceReviewStatus: "pending_admin_confirmation",
    lines: [
      { productId: "frozen-barbeque", productName: "Frozen Kebab Barbeque", variant: "Mini isi 5", quantity: 1, unitPrice: 30000 }
    ],
    subtotal: 30000,
    shippingTotal: 0,
    discountTotal: 0,
    total: 30000,
    createdAt: "2026-08-22T10:40:00+07:00",
    printStatus: "not_printed"
  }
];
